
import React from "react";
import Slider from "react-slick";
import ContentImage from '../common/ContentImage.jsx';
import Link from "next/link";
import { encodeURL } from "../../lib/utils/encodeURL.js";
import moment from 'moment';
import ProductImage from "../common/ProductImage.jsx";

const ProductCarrousel = ({ productData, title }) => {
  const setting = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 6,
    responsive: [
      {
        breakpoint: 1920,
        settings: {
          slidesToShow: 6 ,
          slidesToScroll:  6,
          infinite: false,
          dots: true
        }
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: false,
          dots: true
        }
      },
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }      
    ]
  };
  return (
	<div className="container main-container merchandise-space">
		<h2 className="A-la-venta-esta-sema">{title}</h2>
		<div className="line4"></div>
		<section className="regular mer_filters  mt-30">
			<Slider {...setting}>
				{productData.length > 0 && productData.map((val, i) =>
				<div key={`brand${i}`} className="card-wrapper">
					
					<div className="img-wrapper scale-in">
						<ProductImage slug={encodeURL('/foreign-rights/comic/' + val.slug)} imageName={val.image} imgTag={true} />
					</div>
					
					<Link href={encodeURL('/foreign-rights/comic/' + val.slug)} passHref={true}>
						<div className="product_details">
							<h6 className="title">{val.title} </h6>
							{val.authors.split('|').map((value, index) => (
								<h6 className="authors">{value}</h6>
							))}                    
							{(title=='Next Co-Printing' && val.filesIn) && <h6 className="fob">Files In: {moment(val.filesIn).format('DD/MM/YYYY')}</h6>}
              {(title=='Next Co-Printing' && val.fobDate) && <h6 className="fob">FOB: {moment(val.fobDate).format('DD/MM/YYYY')}</h6>}
							{(title=='Next Releases' && val.editionDate) && <h6 className="fob">{moment(val.editionDate).format('DD/MM/YYYY')}</h6>}
						</div>
					</Link>
				</div>
				)
				}
			</Slider>
		</section>
	</div>
  );
}

export default ProductCarrousel;
